<template>
  <div class="search_bar">
    <NavigationBar />
    <SearchInput
     class="search"
    :marginTop="70" />
  </div>
</template>

<script>
import SearchInput from '@/components/fanClub/column/SearchInput';
import NavigationBar from '@/components/fanClub/column/NavigationBar';

export default {
  components: {
    SearchInput,
    NavigationBar
  },
}
</script>



// WEBPACK FOOTER //
// src/components/fanClub/column/SearchBar.vue